<template lang="pug">
u-app
  u-header(
    title="Unattended Company"
  )
    template(#right)
      u-navigation-menu(
        :items="headerItems"
        variant="link"
      )

  nuxt-layout
    nuxt-page

  u-separator

  u-footer
    template(#left)
      p.text-muted.text-sm &copy; {{ new Date().getFullYear() }} Unattended Company
    template(#right)
      u-navigation-menu(
        :items="footerItems"
        variant="link"
      )
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    headerItems: [
      {
        label: 'Apps',
        to: '/#apps'
      },
      {
        label: 'Contact Us',
        to: '/contact'
      }
    ],
    footerItems: [
      {
        label: 'Apps',
        to: '/#apps'
      },
      {
        label: 'Terms of Service',
        to: '/terms'
      },
      {
        label: 'Privacy Policy',
        to: '/privacy'
      },
      {
        label: 'Contact Us',
        to: '/contact'
      }
    ]
  })
}
</script>

<style lang="stylus" scoped></style>
